import { hasRequiredPermissions } from './acl_helper';

const configCardSelection = (keys, configs, permissions, getImg, isSelected) => {
  return keys
    .map(key => {
      const config = configs[key];
      if (!config) {
        return null;
      }
      if (!hasRequiredPermissions(config.aclVisible, permissions)) {
        return null;
      }
      return {
        key,
        title: config.displayName,
        grayed: !hasRequiredPermissions(config.aclEnabled, permissions),
        imgSrc: getImg(key.toLowerCase().endsWith('heatmap') ? 'heatmap' : key),
        selected: isSelected(key)
      };
    })
    .filter(e => !!e);
};

const configMapSelectionSections = (sections, configs, permissions, getImg, isSelected) => {
  return sections
    .map(({ key, header, cardKeys }) => {
      const cards = configCardSelection(cardKeys, configs, permissions, getImg, isSelected);
      if (cards.length === 0) {
        return null;
      }
      return {
        key,
        header,
        cards
      };
    })
    .filter(e => !!e);
};

export { configMapSelectionSections };
